import axios, { AxiosResponse } from 'axios';
import type { PermissionData } from '@/lib/permission';

const BASE_URL = `${process.env.VUE_APP_API_ROOT}/accounts`;

interface GetResponse {
  data: PermissionData[],
  success: boolean,
}

interface PostResponse {
  data: PermissionData,
  success: boolean,
}

interface DeleteResponse {
  success: boolean,
}

export const permissionService = {
  async getAll(accountSlug: string): Promise<PermissionData[]> {
    const res = await axios.get<GetResponse>(`${BASE_URL}/${accountSlug}/permissions`);
    return res.data.data;
  },

  async add(accountSlug: string, orgSlug: string): Promise<PermissionData | undefined> {
    const res = await axios.post<{ org_slug: string }, AxiosResponse<PostResponse>>(`${BASE_URL}/${accountSlug}/permissions`,
      { org_slug: orgSlug }
    );
    return res.data.success ? res.data.data : undefined;
  },

  async delete(accountSlug: string, orgSlug: string): Promise<boolean> {
    const res = await axios.delete<DeleteResponse>(`${BASE_URL}/${accountSlug}/permissions/${orgSlug}`);
    return res.data.success;
  },
}